import { bl_cms_calendar_event_hdr_RowClass } from '../../../dbschema/bl_cms_calendar_event_hdr.model';
import { bl_cms_calendar_event_notification_queue_RowClass, bl_cms_calendar_event_notification_queue_RowInterface } from '../../../dbschema/bl_cms_calendar_event_notification_queue.model';
import { bl_cms_calendar_event_participant_link_RowClass } from '../../../dbschema/bl_cms_calendar_event_participant_link.model';
import { bl_cms_calendar_hdr_RowClass } from '../../../dbschema/bl_cms_calendar_hdr.model';
import { bl_cms_calendar_member_hdr_RowClass } from '../../../dbschema/bl_cms_calendar_member_hdr.model';
import {BaseContainerModel} from '../../base-container.model';

export class CmsCalendarEventMemberContainerModel extends BaseContainerModel{
    bl_cms_calendar_hdr: bl_cms_calendar_hdr_RowClass = new bl_cms_calendar_hdr_RowClass();
    bl_cms_calendar_member_hdrs: bl_cms_calendar_member_hdr_RowClass[] = [];
    bl_cms_calendar_event_hdrs: bl_cms_calendar_event_hdr_RowClass[] = [];
}